// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2f1e5b5a","239":"fe28619a","732":"c59b3e98"}[chunkId] + ".chunk.js";
};